module.exports = __webpack_public_path__ + "static/media/carouselC.d1cdd327.jpg";